import Swiper from "swiper";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-eventspeakers").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Autoplay, Pagination],
    autoplay: {
      delay: 4000,
    },
    spaceBetween: 16,
    speed: 1000,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
        slidesPerGroup: 2,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 0,
        enabled: false,
      },
    },
  });
});
